export default __webpack_public_path__ + "static/media/gazir.51b95bd5.png";